module.exports = __webpack_public_path__ + "static/media/Deepshot_Logo.5f2e2640.jpg";